<template>
  <div class="container">
    <div class="filter-container">
      <el-button
          class="filter-item"
          size="mini"
          type="primary"
          icon="el-icon-plus"
          @click="handleCreateGroup"
      >新增分组</el-button>
      <el-button
          class="filter-item"
          size="mini"
          icon="el-icon-refresh"
          @click="getList"
      >刷新</el-button>
      <el-button
          class="filter-item"
          size="mini"
          type="warning"
          plain
          icon="el-icon-download"
          :loading="exportLoading"
          @click="handleExport"
      >导出菜单</el-button>
      <el-button
          class="filter-item"
          size="mini"
          type="success"
          plain
          icon="el-icon-upload2"
          :loading="importLoading"
          @click="triggerImportFile"
      >导入菜单</el-button>
      <input
          ref="importInput"
          type="file"
          accept=".json,application/json"
          style="display:none;"
          @change="handleImportFile"
      >
      <el-tooltip
          placement="bottom-end"
          popper-class="menu-manage-tip"
          content="菜单为全局配置(不分组织),仅系统管理员及以上可管理;数字越小排序越靠前,也可点击排序列的上下箭头在同级内调整顺序(分组与分组排、子菜单与同分组菜单排),停用后不在任何管理员菜单中显示。「最低可见身份」控制该菜单对哪些身份可见、可被授予:调高门槛后立即对不达标者隐藏,调低门槛不会自动授予,需在用户管理里手动勾选。导入按 StrID 幂等合并(已存在则更新,不存在则新增)。"
      >
        <i class="el-icon-question tip-icon"></i>
      </el-tooltip>
    </div>
    <el-table
        v-loading="listLoading"
        :data="list"
        size="mini"
        row-key="StrID"
        :tree-props="{ children: 'Childs' }"
        default-expand-all
        border
        fit
        highlight-current-row
        style="width: 100%;"
        :row-class-name="tableRowClassName"
    >
      <el-table-column label="菜单名称" align="left" min-width="200">
        <template v-slot="{ row }">
          <span :class="{ 'disabled-name': row.IsDisabled }">{{ row.StrName }}</span>
          <el-tag
              v-if="row.IsDisabled"
              size="mini"
              type="info"
              style="margin-left:8px;"
          >已停用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="类型" align="center" width="76">
        <template v-slot="{ row }">
          <el-tag v-if="isGroup(row)" size="mini" type="success">分组</el-tag>
          <el-tag v-else size="mini" type="info">菜单</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="排序" align="center" width="112">
        <template v-slot="{ row }">
          <div class="sort-cell">
            <span class="sort-num">{{ row.IntSort }}</span>
            <el-button-group class="sort-btns">
              <el-button
                  size="mini"
                  icon="el-icon-arrow-up"
                  :disabled="!canMove(row, -1)"
                  @click="moveRow(row, -1)"
              />
              <el-button
                  size="mini"
                  icon="el-icon-arrow-down"
                  :disabled="!canMove(row, 1)"
                  @click="moveRow(row, 1)"
              />
            </el-button-group>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="最低可见身份" align="center" width="120">
        <template v-slot="{ row }">
          <el-tag size="mini" :type="identityTagType(row.StrRequiredIdentity)">
            {{ identityShortName(row.StrRequiredIdentity) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center" width="100">
        <template v-slot="{ row }">
          <div class="status-cell">
            <el-tooltip
                v-if="isGroup(row)"
                content="分组不支持停用"
                placement="top"
            >
              <span class="switch-wrap">
                <el-switch
                    v-model="row.IsDisabled"
                    :active-value="false"
                    :inactive-value="true"
                    disabled
                />
              </span>
            </el-tooltip>
            <el-switch
                v-else
                v-model="row.IsDisabled"
                :active-value="false"
                :inactive-value="true"
                @change="handleStatusChange(row)"
            />
            <span :class="row.IsDisabled ? 'status-off' : 'status-on'">
              {{ isGroup(row) ? '始终启用' : (row.IsDisabled ? '已停用' : '已启用') }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          align="center"
          class-name="op-cell"
          fixed="right"
          width="245"
      >
        <template v-slot="{ row }">
          <el-button
              v-if="isGroup(row)"
              type="success"
              size="mini"
              plain
              @click="handleCreateMenu(row)"
          >新增子菜单</el-button>
          <el-button type="primary" size="mini" @click="handleUpdate(row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
        width="460px"
        :title="dialogTitle"
        v-model="dialogFormVisible"
        :close-on-click-modal="false"
    >
      <el-form
          ref="dataForm"
          :rules="rules"
          :model="formModel"
          label-position="right"
          label-width="80px"
          size="small"
      >
        <el-form-item v-if="dialogStatus === 'create'" label="类型">
          <el-radio-group v-model="formModel.type" @change="handleTypeChange">
            <el-radio label="group">顶级分组</el-radio>
            <el-radio label="menu">菜单项</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="formModel.type === 'menu'" label="所属分组" prop="StrParentID">
          <el-select v-model="formModel.StrParentID" placeholder="请选择所属分组" style="width:100%">
            <el-option
                v-for="g in groupOptions"
                :key="g.StrID"
                :label="g.StrName"
                :value="g.StrID"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="菜单名称" prop="StrName">
          <el-input v-model="formModel.StrName" placeholder="请输入菜单名称,同一分组下不可重名" maxlength="30" />
        </el-form-item>
        <el-form-item label="可见身份">
          <el-select v-model="formModel.StrRequiredIdentity" style="width:100%">
            <el-option
                v-for="opt in identityOptions"
                :key="opt.Identity"
                :label="opt.Name"
                :value="opt.Identity"
            />
          </el-select>
          <div class="form-tip">该身份及以上可见、可被授予;选「普通管理员」即全员可见。调高门槛立即对不达标者隐藏,调低不会自动授予,需在用户管理中勾选。</div>
        </el-form-item>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="排序">
              <el-input v-model.number="formModel.IntSort" type="number" min="0" placeholder="默认0,越小越靠前" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-switch
                  v-model="formModel.IsDisabled"
                  active-text="启用"
                  inactive-text="停用"
                  :active-value="false"
                  :inactive-value="true"
                  :disabled="formModel.type === 'group'"
              />
              <div v-if="formModel.type === 'group'" class="form-tip">分组始终启用,不支持停用</div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <el-button size="mini" @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" size="mini" @click="btnSubmit">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage } from "element-plus";
import { BASE_URL } from "@/utils/constants";
import { identityLabel } from "@/utils/identity";

// 身份选项接口异常时的兜底,顺序与后端 /menus/getidentityoptions 一致(从高到低)
const DEFAULT_IDENTITY_OPTIONS = [
  { Identity: 'superAdmin', Name: '超级管理员' },
  { Identity: 'systemAdmin', Name: '系统管理员' },
  { Identity: 'areaManager', Name: '区域管理员' },
  { Identity: 'orgManager', Name: '组织管理员' },
  { Identity: 'manager', Name: '普通管理员(全员可见)' }
];

export default {
  name: 'MenuManage',
  data() {
    const validateParent = (rule, value, callback) => {
      if (this.formModel.type === 'menu' && !value) {
        callback(new Error('请选择所属分组'));
      } else {
        callback();
      }
    };
    return {
      list: [],
      identityOptions: DEFAULT_IDENTITY_OPTIONS,
      listLoading: false,
      sortSaving: false,
      exportLoading: false,
      importLoading: false,
      dialogFormVisible: false,
      dialogStatus: 'create',
      formModel: this.getEmptyForm(),
      rules: {
        StrName: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' }
        ],
        StrParentID: [
          { validator: validateParent, trigger: 'change' }
        ]
      }
    };
  },
  computed: {
    // 顶级分组列表,供"所属分组"下拉使用
    groupOptions() {
      return this.list.filter(item => item.StrParentID === 'System');
    },
    dialogTitle() {
      if (this.dialogStatus === 'create') {
        return this.formModel.type === 'group' ? '新增分组' : '新增菜单';
      }
      return this.formModel.type === 'group' ? '编辑分组' : '编辑菜单';
    }
  },
  created() {
    this.getList();
    this.getIdentityOptions();
  },
  methods: {
    getEmptyForm() {
      return {
        type: 'group',
        StrID: '',
        StrName: '',
        StrParentID: '',
        IntSort: 0,
        IsDisabled: false,
        StrRequiredIdentity: 'manager'
      };
    },
    isGroup(row) {
      return row.StrParentID === 'System';
    },
    // 最低可见身份选项:后端按层级从高到低返回;失败时用本地兜底,不阻塞页面
    getIdentityOptions() {
      this.$axios({
        url: BASE_URL + 'menus/getidentityoptions',
        method: 'get',
        headers: this.authHeaders()
      }).then(res => {
        if (res.data.ok && Array.isArray(res.data.msg) && res.data.msg.length > 0) {
          this.identityOptions = res.data.msg;
        }
      }).catch(() => {
      });
    },
    // 表格里用短标签:manager 直接表达"全员可见",其余用通用身份中文名
    identityShortName(val) {
      const identity = val || 'manager';
      return identity === 'manager' ? '全员可见' : identityLabel(identity);
    },
    identityTagType(val) {
      const map = {
        manager: 'info',
        orgManager: '',
        areaManager: 'warning',
        systemAdmin: 'success',
        superAdmin: 'danger'
      };
      return map[val || 'manager'] !== undefined ? map[val || 'manager'] : 'info';
    },
    tableRowClassName({ row }) {
      return row.IsDisabled ? 'menu-disabled-row' : '';
    },
    authHeaders() {
      return {
        'Content-Type': 'application/json',
        'dataType': 'json',
        'Authorization': localStorage.getItem("token")
      };
    },
    getList() {
      this.listLoading = true;
      this.$axios({
        url: BASE_URL + 'menus/getmenustree',
        method: 'get',
        headers: this.authHeaders()
      }).then(res => {
        if (res.data.ok) {
          // 分组不支持停用:展示层统一归一为启用(排序等全字段提交时会顺带纠正存量脏数据)
          this.list = (res.data.msg || []).map(item => {
            if (item.StrParentID === 'System' && item.IsDisabled) {
              return {...item, IsDisabled: false};
            }
            return item;
          });
        } else {
          ElMessage.error(res.data.msg || '查询菜单失败');
        }
      }).catch(() => {
        ElMessage.error('网络错误,查询菜单失败');
      }).finally(() => {
        this.listLoading = false;
      });
    },
    // 导出全部菜单为 System_Menu.json(后端直接返回 JSON 数组并带下载响应头)
    handleExport() {
      this.exportLoading = true;
      this.$axios({
        url: BASE_URL + 'menus/exportmenus',
        method: 'get',
        responseType: 'blob',
        headers: this.authHeaders()
      }).then(async res => {
        // 越权等失败分支后端仍返回 {ok:false} JSON,blob 方式下需读出文本判断
        const text = await res.data.text();
        let parsed = null;
        try {
          parsed = JSON.parse(text);
        } catch (e) {
          parsed = null;
        }
        if (parsed && parsed.ok === false) {
          ElMessage.error(parsed.msg || '导出失败');
          return;
        }
        let fileName = 'System_Menu.json';
        const disposition = res.headers['content-disposition'];
        if (disposition) {
          const matched = /filename\*?=(?:UTF-8'')?["']?([^;"']+)/i.exec(disposition);
          if (matched && matched[1]) {
            fileName = decodeURIComponent(matched[1].trim());
          }
        }
        const blob = new Blob([text], { type: 'application/json;charset=utf-8' });
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);
        document.body.removeChild(elink);
      }).catch(() => {
        ElMessage.error('网络错误,导出失败');
      }).finally(() => {
        this.exportLoading = false;
      });
    },
    triggerImportFile() {
      // 清空 value,保证重复选择同一文件也能触发 change
      this.$refs.importInput.value = '';
      this.$refs.importInput.click();
    },
    handleImportFile(e) {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      if (!/\.json$/i.test(file.name)) {
        ElMessage.warning('请选择菜单导出的 .json 文件(如 System_Menu.json)');
        return;
      }
      const reader = new FileReader();
      reader.onload = ev => {
        let menus;
        try {
          menus = JSON.parse(ev.target.result);
        } catch (err) {
          ElMessage.error('文件不是有效的 JSON,请选择菜单导出文件');
          return;
        }
        if (!Array.isArray(menus)) {
          ElMessage.error('文件内容应为菜单数组(导出文件的原始内容)');
          return;
        }
        if (menus.length === 0) {
          ElMessage.warning('文件中没有任何菜单');
          return;
        }
        this.$confirm(
            `文件中共 ${menus.length} 条菜单,将按 StrID 幂等导入:已存在则更新,不存在则新增。确定导入吗?`,
            '导入确认',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }
        ).then(() => {
          this.doImport(menus);
        }).catch(() => {
        });
      };
      reader.onerror = () => {
        ElMessage.error('文件读取失败');
      };
      reader.readAsText(file, 'utf-8');
    },
    // 导入接口要求裸 JSON 数组作为请求体(不是 {ok,msg} 包装)
    doImport(menus) {
      this.importLoading = true;
      this.$axios({
        url: BASE_URL + 'menus/importmenus',
        method: 'post',
        data: JSON.stringify(menus),
        headers: this.authHeaders()
      }).then(res => {
        if (res.data.ok) {
          const r = res.data.msg || {};
          ElMessage.success(
              `导入完成:共 ${r.Total || 0} 条,新增 ${r.Inserted || 0},更新 ${r.Updated || 0},跳过 ${r.Skipped || 0}`
          );
          this.getList();
        } else {
          ElMessage.error(res.data.msg || '导入失败');
        }
      }).catch(() => {
        ElMessage.error('网络错误,导入失败');
      }).finally(() => {
        this.importLoading = false;
      });
    },
    handleCreateGroup() {
      this.dialogStatus = 'create';
      this.formModel = this.getEmptyForm();
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    // row 为点击"新增子菜单"的分组行;无 row 时默认选中第一个分组
    handleCreateMenu(row) {
      this.dialogStatus = 'create';
      this.formModel = this.getEmptyForm();
      this.formModel.type = 'menu';
      if (row && this.isGroup(row)) {
        this.formModel.StrParentID = row.StrID;
      } else if (this.groupOptions.length > 0) {
        this.formModel.StrParentID = this.groupOptions[0].StrID;
      }
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    handleUpdate(row) {
      this.dialogStatus = 'update';
      this.formModel = {
        ...this.getEmptyForm(),
        ...row,
        type: this.isGroup(row) ? 'group' : 'menu',
        // 存量数据可能缺该字段,缺省按全员可见回显
        StrRequiredIdentity: row.StrRequiredIdentity || 'manager'
      };
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    // 新增弹窗切换类型:分组不支持停用,切回分组时复位为启用
    handleTypeChange(type) {
      if (type === 'group') {
        this.formModel.IsDisabled = false;
      }
    },
    buildPayload() {
      const payload = {
        StrName: (this.formModel.StrName || '').trim(),
        StrParentID: this.formModel.type === 'group' ? 'System' : this.formModel.StrParentID,
        IntSort: Math.max(0, parseInt(this.formModel.IntSort, 10) || 0),
        // 分组始终启用,即使存量数据 IsDisabled=true 也借编辑提交纠正为 false
        IsDisabled: this.formModel.type === 'group' ? false : this.formModel.IsDisabled,
        StrRequiredIdentity: this.formModel.StrRequiredIdentity || 'manager'
      };
      if (this.dialogStatus === 'update') {
        payload.StrID = this.formModel.StrID;
      }
      return payload;
    },
    // 表格行上的快捷操作(启停/排序)同样走 updatemenu 全字段提交,
    // StrRequiredIdentity 漏传会被后端归一为 manager,必须原样带回。
    buildRowParam(row, extra) {
      return {
        StrID: row.StrID,
        StrName: row.StrName,
        StrParentID: row.StrParentID,
        IntSort: row.IntSort,
        IsDisabled: row.IsDisabled,
        StrRequiredIdentity: row.StrRequiredIdentity || 'manager',
        ...extra
      };
    },
    btnSubmit() {
      this.$refs['dataForm'].validate(valid => {
        if (!valid) return;
        const isCreate = this.dialogStatus === 'create';
        this.$axios({
          url: BASE_URL + (isCreate ? 'menus/createmenu' : 'menus/updatemenu'),
          method: 'post',
          data: JSON.stringify(this.buildPayload()),
          headers: this.authHeaders()
        }).then(res => {
          if (res.data.ok) {
            ElMessage.success(isCreate ? '添加成功' : '编辑成功');
            this.dialogFormVisible = false;
            this.getList();
          } else {
            ElMessage.error(res.data.msg || '保存失败');
          }
        }).catch(() => {
          ElMessage.error('网络错误,保存失败');
        });
      });
    },
    // 表格内启停开关:直接走 updatemenu,失败时以服务端数据为准刷新
    handleStatusChange(row) {
      const parem = this.buildRowParam(row);
      this.$axios({
        url: BASE_URL + 'menus/updatemenu',
        method: 'post',
        data: JSON.stringify(parem),
        headers: this.authHeaders()
      }).then(res => {
        if (res.data.ok) {
          ElMessage.success(row.IsDisabled ? '已停用' : '已启用');
        } else {
          ElMessage.error(res.data.msg || '状态更新失败');
          this.getList();
        }
      }).catch(() => {
        ElMessage.error('网络错误,状态更新失败');
        row.IsDisabled = !row.IsDisabled;
      });
    },
    // 同级列表:分组在顶级互排,子菜单只在所属分组内互排
    getSiblings(row) {
      if (this.isGroup(row)) {
        return this.list;
      }
      const parent = this.list.find(g => g.StrID === row.StrParentID);
      return parent ? (parent.Childs || []) : [];
    },
    // dir:-1 上移,1 下移;排序保存期间统一禁用
    canMove(row, dir) {
      if (this.sortSaving) return false;
      const siblings = this.getSiblings(row);
      const idx = siblings.indexOf(row);
      if (idx < 0) return false;
      return dir < 0 ? idx > 0 : idx < siblings.length - 1;
    },
    moveRow(row, dir) {
      const siblings = this.getSiblings(row);
      const idx = siblings.indexOf(row);
      const targetIdx = idx + dir;
      if (idx < 0 || targetIdx < 0 || targetIdx >= siblings.length) return;
      const swapWith = siblings[targetIdx];
      let changed;
      if (row.IntSort !== swapWith.IntSort) {
        // 常规情况:相邻两行互换排序值即可完成位置交换
        changed = [
          { row, IntSort: swapWith.IntSort },
          { row: swapWith, IntSort: row.IntSort }
        ];
      } else {
        // 排序值相同时服务端顺序不确定,按移动后的位置对整组重新连续编号(自然数 1,2,3...)
        const newOrder = siblings.slice();
        newOrder[idx] = newOrder[targetIdx];
        newOrder[targetIdx] = row;
        changed = [];
        newOrder.forEach((item, i) => {
          const IntSort = i + 1;
          if (item.IntSort !== IntSort) {
            changed.push({ row: item, IntSort });
          }
        });
      }
      this.saveSortChanges(changed);
    },
    // 逐条走 updatemenu 持久化;先做本地乐观更新,任一失败则以服务端数据刷新回滚
    saveSortChanges(changed) {
      if (!changed.length) return;
      this.sortSaving = true;
      changed.forEach(({ row, IntSort }) => {
        row.IntSort = IntSort;
      });
      Promise.all(changed.map(({ row, IntSort }) => {
        const parem = this.buildRowParam(row, { IntSort });
        return this.$axios({
          url: BASE_URL + 'menus/updatemenu',
          method: 'post',
          data: JSON.stringify(parem),
          headers: this.authHeaders()
        }).then(res => {
          if (!res.data.ok) {
            throw new Error(res.data.msg || '排序更新失败');
          }
        });
      })).then(() => {
        ElMessage.success('排序已调整');
        this.getList();
      }).catch(err => {
        ElMessage.error(err.message || '网络错误,排序更新失败');
        this.getList();
      }).finally(() => {
        this.sortSaving = false;
      });
    },
    handleDelete(row) {
      const isGroup = this.isGroup(row);
      if (isGroup && row.Childs && row.Childs.length > 0) {
        ElMessage.warning('该分组下还有子菜单,请先删除或移出其子菜单后再删除分组');
        return;
      }
      const label = isGroup ? '分组' : '菜单';
      const tip = isGroup
          ? `确定删除分组「${row.StrName}」吗?删除后将从所有管理员的菜单中消失。`
          : `确定删除菜单「${row.StrName}」吗?删除后将从所有管理员的权限中移除。`;
      this.$confirm(tip, '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios({
          url: BASE_URL + 'menus/deletemenu',
          method: 'post',
          data: JSON.stringify({ StrID: row.StrID }),
          headers: this.authHeaders()
        }).then(res => {
          if (res.data.ok) {
            ElMessage.success('删除成功');
            this.getList();
          } else {
            ElMessage.error(res.data.msg || '删除失败');
          }
        }).catch(() => {
          ElMessage.error('网络错误,删除失败');
        });
      }).catch(() => {
      });
    }
  }
};
</script>

<style scoped>
.tip-icon {
  margin-left: auto;
  font-size: 16px;
  color: #909399;
  cursor: help;
}
.tip-icon:hover {
  color: #409eff;
}
.disabled-name {
  color: #c0c4cc;
}
.form-tip {
  font-size: 12px;
  line-height: 1.5;
  color: #909399;
  margin-top: 4px;
}
.sort-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}
.sort-num {
  margin-right: 6px;
}
/* 上下移按钮:mini 基础上再压缩,保证排序号与按钮同一行 */
.sort-btns .el-button--mini {
  min-height: 22px;
  padding: 4px 7px;
  margin-left: 0;
}
.status-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}
.status-cell .el-switch {
  margin-right: 6px;
}
/* disabled 开关不响应鼠标事件,由外层 span 承接 tooltip 的悬停 */
.status-cell .switch-wrap {
  display: inline-flex;
  align-items: center;
  margin-right: 6px;
}
.status-on {
  color: #67c23a;
}
.status-off {
  color: #909399;
}
</style>
<style>
/* 停用行整行变灰,row-class-name 不带 scoped 才能命中单元格内文本 */
.el-table .menu-disabled-row td {
  color: #c0c4cc;
}
/* 工具栏问号气泡:长说明限宽换行 */
.menu-manage-tip {
  max-width: 340px;
  line-height: 1.6;
}
/* 操作列三个按钮强制一行显示 */
.el-table .op-cell .cell {
  white-space: nowrap;
}
/* 操作列按钮:在 mini 基础上再压缩一档 */
.el-table .op-cell .el-button--mini {
  min-height: 24px;
  padding: 5px 10px;
}
/* 状态列开关:beta.33 的 el-switch 无 size 属性,按比例缩到 32x16 */
.status-cell .el-switch__core {
  width: 32px;
  height: 16px;
  border-radius: 8px;
}
.status-cell .el-switch__core .el-switch__action {
  width: 12px;
  height: 12px;
}
.status-cell .el-switch.is-checked .el-switch__core .el-switch__action {
  margin-left: -13px;
}
</style>
